/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_DISPATCH_RECEIVE,
    CURRENT_DISPATCH_REQUEST,
    CURRENT_DISPATCH_REQUEST_SUCCESS,
    CURRENT_DISPATCH_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_DISPATCH_REQUEST]: () => true,
    [CURRENT_DISPATCH_REQUEST_SUCCESS]: () => false,
    [CURRENT_DISPATCH_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_DISPATCH_RECEIVE]: (state, action) => action.payload.dispatchplan,
});

export const error = createReducer(false, {
    [CURRENT_DISPATCH_REQUEST]: () => false,
    [CURRENT_DISPATCH_REQUEST_SUCCESS]: () => false,
    [CURRENT_DISPATCH_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
